import { render } from "./AvailabilitySubscribe.vue?vue&type=template&id=6f15c356&lang=html"
import script from "./AvailabilitySubscribe.vue?vue&type=script&lang=js"
export * from "./AvailabilitySubscribe.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/shininvest.ru/htdocs/local/vue-roscar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__